<script>
import _ from 'lodash'
export default {
  props: {
    phaseTwoUsers: {
      type: Array,
      required: true,
    },
    licenseStates: {
      type: Array,
      required: true,
    },
    submitting: {
      type: Boolean,
    },
  },
  data() {
    return {
      additionalLoPhaseTwoLicensesIds: [],
      additionalLoPhaseTwoLicenses: [],
    }
  },
  watch: {
    licenseStates() {
      this.loadLicenseStates()
    },
  },
  created() {
    this.loadLicenseStates()
  },
  methods: {
    emptyAdditionalLoPhaseTwoLicensesIds() {
      const usersWithLicenses = this.getAdditionalLoPhaseTwoLicenses().map((user) => user.id)
      return _.difference(this.additionalLoPhaseTwoLicensesIds, usersWithLicenses)
    },

    getAdditionalLoPhaseTwoLicenses() {
      return this.additionalLoPhaseTwoLicensesIds
        .reduce((acc, id) => {
          const requestedLicenses = _(this.additionalLoPhaseTwoLicenses[id])
            .values()
            .filter((state) => state.active[0])
            .map((state) => {
              return {
                state: state.state,
                number: state.number,
              }
            })
            .value()

          acc = [...acc, { id, requestedLicenses }]

          return acc
        }, [])
        .filter((user) => user.requestedLicenses.length)
    },

    loadLicenseStates() {
      if (!this.licenseStates.length) {
        this.additionalLoPhaseTwoLicensesIds = []
        this.additionalLoPhaseTwoLicenses = []
        return
      }
      this.additionalLoPhaseTwoLicenses = this.phaseTwoUsers.reduce((acc, user) => {
        acc[user.id] = this.licenseStates.reduce((acc, state) => {
          acc[state] = this.additionalLoPhaseTwoLicenses[user.id]?.[state] ?? {
            active: [],
            number: null,
            state,
          }
          return acc
        }, {})
        return acc
      }, {})
    },

    isStateActiveForLO(userId, state) {
      return this.additionalLoPhaseTwoLicenses[userId]?.[state]?.active[0]
    },

    isOnlyOneStateForCheckedLO(userId) {
      return this.additionalLoPhaseTwoLicensesIds.includes(userId) && this.licenseStates.length === 1
    },

    selectLO(userId) {
      if (this.isOnlyOneStateForCheckedLO(userId)) {
        this.additionalLoPhaseTwoLicenses[userId][this.licenseStates[0]].active = ['1']
      }

      if (!this.additionalLoPhaseTwoLicensesIds.includes(userId)) {
        Object.keys(this.additionalLoPhaseTwoLicenses[userId]).forEach((state) => {
          this.additionalLoPhaseTwoLicenses[userId][state].active = []
          this.additionalLoPhaseTwoLicenses[userId][state].number = null
        })
      }
    },
  },
}
</script>

<template>
  <div>
    <div v-if="phaseTwoUsers.length && licenseStates.length">
      <div>
        <h2 class="color-primary-blue mb-5 mt-2">
          Please select Phase 2 LOs who should be granted the license(s) in MottoCenter.
        </h2>
      </div>
      <div v-for="phaseTwoUser in phaseTwoUsers" :key="phaseTwoUser.id">
        <div :class="$style.phaseTwoLicenseFormContainer">
          <div :class="$style.phaseTwoLoNameField">
            <BaseCheckbox
              v-model="additionalLoPhaseTwoLicensesIds"
              :input-value="phaseTwoUser.id"
              :label="phaseTwoUser.name"
              :disabled="submitting"
              @input="selectLO(phaseTwoUser.id)" />
          </div>
          <div :class="$style.stateFields">
            <div v-for="state in licenseStates" :key="state.id" :class="$style.stateField">
              <BaseCheckbox
                v-model="additionalLoPhaseTwoLicenses[phaseTwoUser.id][state].active"
                input-value="1"
                :style="{
                  'pointer-events':
                    isOnlyOneStateForCheckedLO(phaseTwoUser.id) &&
                    additionalLoPhaseTwoLicenses[phaseTwoUser.id][state].active[0]
                      ? 'none'
                      : 'auto',
                }"
                :disabled="!additionalLoPhaseTwoLicensesIds.includes(phaseTwoUser.id) || submitting"
                :label="state" />
              <BaseInputText
                v-model="additionalLoPhaseTwoLicenses[phaseTwoUser.id][state].number"
                class="ml-20"
                maxlength="30"
                :disabled="!isStateActiveForLO(phaseTwoUser.id, state) || submitting"
                :name="state + ' - '"
                placeholder="License Number" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.phaseTwoLicenseFormContainer {
  @media (max-width: $sm-breakpoint) {
    flex-direction: column;
  }

  display: flex;
  justify-content: space-between;
}

.phaseTwoLoNameField {
  @media (max-width: $sm-breakpoint) {
    width: auto;
  }

  width: 35%;
}

.stateFields {
  @media (max-width: $sm-breakpoint) {
    margin: 10px 0 0 10px;
  }

  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: flex-end;
  margin: -10px 0 25px 10px;
}

.stateField {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
</style>
